import React, { Fragment } from "react";
import { Route, Switch, Redirect } from "react-router-dom";

import Login from "layouts/SignIn";
import AdminRoutes from './AdminRoutes';

const Routes = () => (
  <Fragment>
    <Route path="/login" component={Login} />
    {/* TODO: better redirect strategy */}
    <Switch>
      <Route
        path="/admin"
        component={AdminRoutes}
      />
      <Redirect from="*" to='/login' />
    </Switch>
  </Fragment>
);

export default Routes;
